<template>
	<div class="content my-0 py-1">
		<div class="container-fluid">
			<div class="row">
				<div class="col-12 mt-2 py-0">

					<div class="d-flex align-items-center">
						<div class="d-flex align-items-center">
						<h5 style="font-size: 12px;" class="m-0 p-0 text-white bg-primary d-inline shadow-sm border border-primary rounded px-2 py-1">
							SERVICE INVOICE
						</h5>
					</div>
					</div>
					<button 
						class="float-right btn btn-primary shadow" 
						v-on:click="formInvoiceAirtimeActive=!formInvoiceAirtimeActive"
						v-if="['master_admin','admin','finance'].includes(role) && role !== 'root'">
						ADD NEW
					</button>
				</div>
				<transition name="fade">
					<div class="col-12  my-2 py-0" v-if="formInvoiceAirtimeActive">
						<div class="row p-3 mx-2 bg-white shadow">
							
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">SPKP ID</label>
								<smart-search init url="/api/seeker/sold-hardware-setup" 
											  :label-tag="['id_transmitter']"
								              key-tag="id_transmitter"
								              v-on:update="(data)=>smartSearchAddIdTransmitter(data)"
								              :search-value="newhardwareidlabel"
								              @update-direct="(label)=>newhardwareidlabel=label">
								</smart-search>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">SERIAL NUMBER</label>
								<div class="form-control w-100 rounded">
									{{
										selectedHardwareSetup.serial_number != 
										undefined && selectedHardwareSetup.serial_number != null ? 
										selectedHardwareSetup.serial_number.serial_number : "-"
									}}
								</div>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">NO JB</label>
								<div class="form-control w-100 rounded">
									{{
										selectedHardwareSetup.jb != 
										undefined && selectedHardwareSetup.jb != null ? 
										selectedHardwareSetup.jb.serial_number : "-"
									}}
								</div>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">SHIP NAME </label>
								<div class="form-control w-100 rounded">
									{{
										selectedHardwareSetup.vessel != 
										undefined && selectedHardwareSetup.vessel.name != null ? 
										selectedHardwareSetup.vessel.name : "-"
									}}
								</div>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">OWNER</label>
								<div class="form-control w-100 rounded">
									{{
										selectedHardwareSetup.vessel != 
										undefined && selectedHardwareSetup.vessel.client.legal_name != null ? 
										selectedHardwareSetup.vessel.client.legal_name : "-"
									}}
								</div>
							</div>
						
							<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">NO INVOICE</label>
								<div class="input-group">
									<!-- Input for invoice sequence number -->
									<input type="text" class="form-control w-25 rounded"
									v-model="invoiceId"
									@input="updateInvoiceNumber"
									maxlength="6"
									style="background-color: #ffffff;" />

									<!-- Roman month options -->
									<select class="form-control w-25 rounded"
									v-model="selectedMonth"
									@change="updateInvoiceNumber">
									<option v-for="(roman, index) in romanMonths"
											:key="index"
											:value="roman">
										{{ roman }}
									</option>
									</select>

									<!--Input for year -->
									<input type="number" class="form-control w-25 rounded"
									v-model="selectedYear"
									@input="updateInvoiceNumber"
									min="2000"
									style="background-color: #ffffff;" />

									<!-- Invoice result format (readonly) -->
									<input type="text" class="form-control w-75 rounded"
									:value="formattedInvoiceNumber"
									readonly style="background-color: #f0f0f0;" />
								</div>
							</div>

							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">INVOICE DATE</label>
								<b-form-datepicker 
									today-button 
									reset-button 
									close-button
									:date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}"
									id="datepicker-invoice-date" 
									v-model="newInvoiceAirtime.invoiceDate" 
									class="mb-2">
									{{ newInvoiceAirtime.invoiceDate }}
								</b-form-datepicker>
							</div>
							
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">DUE DATE </label>
								<b-form-datepicker 
									today-button 
									reset-button 
									close-button
									:date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}"
									id="datepicker-due-date" v-model="newInvoiceAirtime.dueDateInvoice" class="mb-2">
									{{ newInvoiceAirtime.dueDateInvoice }}
								</b-form-datepicker>
							</div>

								<div class="col-12 col-md-6 col-lg-4 mt-2">
									<label class="d-block">START OF AIRTIME</label>
									<b-form-datepicker
										today-button
										reset-button
										close-button
										:date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}"
										id="datepicker-start-period"
										v-model="newInvoiceAirtime.startPeriod"
										class="mb-2"
									>
									</b-form-datepicker>
								</div>

							<div class="col-12 col-md-6 col-lg-4 mt-2" v-if="false">
								<label class="d-block">PEFORMA</label>
								<smart-select name="proforma" :options="proformaTypeOptions"
								              v-on:update="updateNewIiProforma"></smart-select>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">QR CODE</label>
								<smart-select name="qr_code" :options="qrCodeTypeOptions"
								              v-on:update="updateNewQrCode"></smart-select>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">HARGA AIRTIME</label>
										<smart-search init url="/api/master/seeker/airtime-price"
											  key-tag="id"
								              v-on:update="(data)=>smartSearchAirtimePrice(data)"
								              :search-value="newairtimepricelabel"
											  :label-tag="['name_airtime_price','price']" 
								              @update-direct="(label)=>newairtimepricelabel=label"
								              @input="calculateAmount">
										</smart-search>
								<!-- Displays price if available -->
								<div v-if="newAirtimePrice > 0" class="mt-2" text-danger>
									<strong>Price:</strong> Rp {{ newAirtimePrice.toLocaleString() }}
								</div>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">DURASI AIRTIME</label>
								<div class="form-control w-100 rounded">{{ newInvoiceAirtime.airtimeMonthDuration }}
									Month
								</div>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">PPN-VAT</label>
								<smart-select name="ppn" 
									:options="ppnTypeOptions" usedefault
									:value="newInvoiceAirtime.ppn" 
									v-on:update="updateNewPpn">
								</smart-select>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">DISCOUNT</label>
								<smart-search init url="/api/master/seeker/discount" :label-tag="['discount']"
								              key-tag="discount" @clear="smartSearchDiscount(null)"
								              v-on:update="(data)=>smartSearchDiscount(data)"
								              :search-value="newairtimediskonlabel"
								              @update-direct="(label)=>newairtimediskonlabel=label">
								</smart-search>
							</div>
		                    <div class="col-12 col-md-6 col-lg-4 mt-2">
		                      <label class="d-block">ACCOUNT BANK</label>
			                    <smart-search 
											:search-value="newInvoiceAirtime.label_bank" init url="/api/master/seeker/bank" 
											usedefault :default-value="newInvoiceAirtime.label_bank" key-tag="nama" 
											:label-tag="['no_rekening','nama']" 
											v-on:update="(data)=>{newInvoiceAirtime.id_bank=data.id}"  
											@update-direct="(label)=>newInvoiceAirtime.label_bank=label">
								</smart-search>
		                    </div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">PIC</label>
								<input type="text" class="form-control w-100 rounded" v-model="newInvoiceAirtime.pic"/>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">POSITION</label>
								<input type="text" class="form-control w-100 rounded"
								       v-model="newInvoiceAirtime.division"/>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">INFORMATION</label>
								<textarea type="text" class="form-control w-100 rounded"
								          v-model="newInvoiceAirtime.notes"/>
							</div>
							<div class="col-12 mt-2">
								<br><br>
								<hr>
								<div class="row">
									<label class="d-block col-12 col-md-6 text-right">Harga</label>
									<div type="text" class="form-control col-12 col-md-6  text-right w-100 rounded">
										{{ newInvoiceAirtime.airtimePrice | numeral("0,0") }}
									</div>
								</div>
							</div>
							<div class="col-12 mt-2">
								<div class="row">
									<label class="d-block col-12 col-md-6 text-right">Diskon</label>
									<div type="text" class="col-12 col-md-6 form-control text-right w-100 rounded">
										-{{ newInvoiceAirtime.discount | numeral("0,0") }}
									</div>
								</div>
							</div>
							<div class="col-12 mt-2">
								<div class="row">
									<label class="d-block col-12 col-md-6 text-right">Sub total</label>
									<div type="text" class="col-12 col-md-6 form-control text-right w-100 rounded">
										{{ newInvoiceAirtime.subtotal | numeral("0,0") }}
									</div>
								</div>
							</div>
							<div class="col-12 mt-2">
								<div class="row">
									<label class="d-block col-12 col-md-6 text-right">Total PPN</label>
									<div type="text" class="col-12 col-md-6 form-control text-right w-100 rounded">
										{{ newInvoiceAirtime.totalPPN | numeral("0,0") }}
									</div>
								</div>
							</div>
							<div class="col-12 mt-2">
								<div class="row">
									<label class="d-block col-12 col-md-6 text-right">Total</label>
									<div type="text" class="form-control w-100 col-12 text-right col-md-6 rounded">
										<b>{{newInvoiceAirtime.total | numeral("0,0") }}</b>
									</div>
								</div>
							</div>
							<div class="col-12 mt-3">
								<div class="w-100 align-items-center justify-content-start"
								     v-if="newInvoiceAirtimeSaved">
									<div class="alert alert-success" role="alert">
										Successfully saved New Airtime Invoice.
									</div>
								</div>
							</div>

							<div class="col-12 mt-3">
								<div class="w-100 align-items-center justify-content-start"
								     v-if="errorNewInvoiceAirtime">
									<div class="alert alert-danger" role="alert">
										<div class="my-0">
											<p class="d-block mt-1">Failed to Save New Airtime Invoice.</p>
										</div>
										<div v-for="err in errorInvoiceItemList" v-bind:key="err" class="my-0">
											<p v-for="note in err" v-bind:key="note" class="d-block mt-1">{{ note }}</p>
										</div>
									</div>
								</div>
							</div>
							<div class="col-12 mt-3">
								<div class="d-flex align-items-center justify-content-start"
								     v-if="savingNewInvoiceAirtime">
									<div class="spinner-border" role="status" aria-hidden="true"></div>
									<strong class=" ml-2">Saving data, wait a moment.</strong>
								</div>
								<button class="btn btn-primary float-right" type="button"
								        v-on:click="savenewInvoiceAirtime">Submit
								</button>
							</div>
						</div>
					</div>
				</transition>
				
				<div class="col-12  my-2 py-0">
					 <div class="search-container">
						<input 
							type="text"
							class="search-input"
							placeholder="search no invoice / vessel / client"
							v-model="searchTerm"
							@input="doSearch"
						/>
					</div>
					<!-- TAB BUTTON -->
					<ul class="nav nav-tabs mb-2">
						<li class="nav-item">
							<button
								class="nav-link"
								:class="[selectedTab==0 ? 'active' : '']" 
								href="#"
								@click="govermentTabe">
								GOVERNMENT
							</button>
						</li>

						<li class="nav-item">
							<button
								class="nav-link"
								:class="[selectedTab==2?'active':'']" 
								href="#"
							    v-on:click="selectedTab=2">
								NON GOVERNMENT
							</button>
						</li>
					</ul>
					<div class="col-12  my-2 py-0" v-if="selectedTab==0">
					<datatable ref="myTable"
							   :currentIdx="currentPage" 
							   :datas="filteredInvoiceAirtimes"
					           :structure="tableStructure" 
							   :init="loadData"
					           :next-url="nextUrl"
							   :prev-url="prevUrl" 
							   :show-search="false"
							   :hide-pagination="true"
					            use-filter 
							    use-seeker 
							    seeker-url="/api/pemesanan/seeker/invoice-airtime"
					            use-xml xml-url="xmlUrl"
								@searching="applyFilter"
							    @change-page="(isNext)=>{changePage(isNext)}"
					            @refetch="(row)=>{rowLimit=row;getInvoiceAirtimes()}"
							    >
							
							<template #customcell={obj,index}>

								<td>{{ ((currentPage - 1) * perPage) + index + 1  }}</td>
								<td>{{ obj.invoice_item_metadata.order_metadata.hardware_setup.vessel.client.customer_id }}</td>
								<td>{{ obj.invoice_no }}</td>
								<td>{{ obj.invoice_item_metadata.order_metadata.hardware_setup.vessel.client.legal_name }}</td>
								<td>{{ obj.invoice_item_metadata.order_metadata.hardware_setup.serial_number.serial_number }}</td>
								<td>{{ obj.invoice_item_metadata.order_metadata.hardware_setup.vessel.name }}</td>
								<td v-if="obj.invoice_item_metadata 
										&& obj.invoice_item_metadata.order_metadata
										&& obj.invoice_item_metadata.order_metadata.hardware_setup
										&& obj.invoice_item_metadata.order_metadata.hardware_setup.device_status">
										
								{{ obj.invoice_item_metadata.order_metadata.hardware_setup.device_status.status_code }}

								</td>

								<td v-else>-</td>
								<td>{{ obj.invoice_item_metadata.order_metadata.hardware_setup.forward }}</td>
								<td>{{ obj.invoice_item_metadata.order_metadata.hardware_setup.vessel.gt }}</td>
								<td>{{ obj.invoice_item_metadata.order_metadata.hardware_setup.vessel.client.npwp }}</td>
								<td>{{ obj.invoice_item_metadata.order_metadata.hardware_setup.vessel.type_vessel }}</td>
								<td>{{ obj.invoice_date | timeformat }}</td>
								<td>{{ obj.start_period | timeformat }}</td>
								<td>{{ obj.end_periode | timeformat }}</td>
								
								<td>
									<b-button v-b-modal.modal-sap class="btn btn-success"
											:href="'https://api-billing.megahsurya.com/api/invoice/airtime-sap/'+obj.id">
										<b>SAP</b></b-button>
								</td>
								<td>
									<!-- Dropdown Pilihan -->
									<b-dropdown text="Actions" variant="primary" class="mb-2">
										<b-dropdown-item :href="'https://api-billing.megahsurya.com/api/invoice/airtime/'+obj.id+'?qr=yes'" title="Invoice">
										<b-icon icon="printer"></b-icon> Invoice
									</b-dropdown-item>
									<b-dropdown-item :href="'https://api-billing.megahsurya.com/api/invoice/airtime/'+obj.id+'?proforma=yes&qr=yes'" title="Proforma invoice">
										<b-icon icon="printer"></b-icon> PI
									</b-dropdown-item>
									<b-dropdown-item v-b-modal.modal-renewal-invoice @click="selectedIdforEdit=index" v-if="['master_admin','admin','finance'].includes(role)" title="Edit">
										<b-icon icon="arrow-repeat"></b-icon> Renewal
									</b-dropdown-item>
									<b-dropdown-item v-b-modal.modal-detail-histories @click="getHistories(obj.id)" title="History">
										<b-icon icon="clock-history"></b-icon> History
									</b-dropdown-item>
									<b-dropdown-item v-b-modal.modal-detail-invoice-airtime @click="selectedDetail=index" title="View">
										<b-icon icon="eye"></b-icon> View
									</b-dropdown-item>
									<b-dropdown-item v-b-modal.modal-edit-invoice @click="selectedIdforEdit=index" v-if="['master_admin','admin','finance'].includes(role)" title="Edit">
										<b-icon icon="pencil-square"></b-icon> Edit
									</b-dropdown-item>
									<b-dropdown-item v-b-modal.modal-delete @click="deleteId=obj.id;itemToDelete=obj" v-if="['master_admin','admin'].includes(role)" title="Delete">
										<b-icon icon="trash"></b-icon> Delete
									</b-dropdown-item>
									</b-dropdown>

								</td>
							
							</template>
							
					</datatable>
					<!-- Pagination info + Prev Next -->
					<div class="d-flex justify-content-between align-items-center mt-2">

						<!-- Showing info -->
						<div class="text-muted">
							Showing {{ (currentPage - 1) * perPage + 1 }}
							to {{ ((currentPage - 1) * perPage) + filteredInvoiceAirtimes.length }}
							of {{ totalItems }} entries
						</div>

						<!-- Prev Next Buttons -->
						<div>
							<b-button 
								class="mr-2"
								variant="outline-primary"
								:disabled="!prevUrl"
								@click="changePage(false)"
							>
								Prev
							</b-button>

							<b-button 
								variant="outline-primary"
								:disabled="!nextUrl"
								@click="changePage(true)"
							>
								Next
							</b-button>
						</div>

					</div>
					</div>
				</div>
				<!-- Tabel List INV NON GOVERMENT -->
				 <div class="col-12  my-2 py-0" v-if="selectedTab==2">
					<datatable ref="myTable"
							   :currentIdx="currentPage" 
							   :datas="filteredInvoiceAirtimesNonGov"
					           :structure="tableStructurenongov" 
							   :init="loadData"
					           :next-url="nextUrl"
							   :prev-url="prevUrl" 
							   :show-search="false"
							   :hide-pagination="true"
					            use-filter 
							    use-seeker 
							    seeker-url="/api/pemesanan/invoice-airtime-non-goverment"
					            use-xml xml-url="xmlUrl"
								@searching="applyFilter"
							    @change-page="(isNext)=>{changePage(isNext)}"
					            @refetch="(row)=>{rowLimit=row;getInvoiceAirtimesNonGov()}"
							    >
							
							<template #customcell={obj,index}>

								<td>{{ ((currentPage - 1) * perPage) + index + 1  }}</td>
								<td>{{ obj.invoice_item_metadata.order_metadata.hardware_setup.vessel.client.customer_id }}</td>
								<td>{{ obj.invoice_no }}</td>
								<td>{{ obj.invoice_item_metadata.order_metadata.hardware_setup.vessel.client.legal_name }}</td>
								<td>{{ obj.invoice_item_metadata.order_metadata.hardware_setup.serial_number.serial_number }}</td>
								<td>{{ obj.invoice_item_metadata.order_metadata.hardware_setup.vessel.name }}</td>
								<td>{{ obj.invoice_item_metadata.order_metadata.hardware_setup.forward }}</td>
								<td>{{ obj.invoice_item_metadata.order_metadata.hardware_setup.vessel.gt }}</td>
								<td>{{ obj.invoice_item_metadata.order_metadata.hardware_setup.vessel.client.npwp }}</td>
								<td>{{ obj.invoice_item_metadata.order_metadata.hardware_setup.vessel.type_vessel }}</td>
								<td>{{ obj.invoice_date | timeformat }}</td>
								<td>{{ obj.start_period | timeformat }}</td>
								<td>{{ obj.end_periode | timeformat }}</td>
								
								<td>
									<!-- Dropdown Pilihan -->
									<b-dropdown text="Actions" variant="primary" class="mb-2">
										<b-dropdown-item :href="'https://api-billing.megahsurya.com/api/invoice/airtime/'+obj.id+'?qr=yes'" title="Invoice">
										<b-icon icon="printer"></b-icon> Invoice
									</b-dropdown-item>
									<b-dropdown-item :href="'https://api-billing.megahsurya.com/api/invoice/airtime/'+obj.id+'?proforma=yes&qr=yes'" title="Proforma invoice">
										<b-icon icon="printer"></b-icon> PI
									</b-dropdown-item>
									<b-dropdown-item v-b-modal.modal-renewal-invoice @click="selectedIdforEdit=index" v-if="['master_admin','admin','finance'].includes(role)" title="Edit">
										<b-icon icon="arrow-repeat"></b-icon> Renewal
									</b-dropdown-item>
									<b-dropdown-item v-b-modal.modal-detail-histories @click="getHistories(obj.id)" title="History">
										<b-icon icon="clock-history"></b-icon> History
									</b-dropdown-item>
									<b-dropdown-item v-b-modal.modal-detail-invoice-airtime @click="selectedDetail=index" title="View">
										<b-icon icon="eye"></b-icon> View
									</b-dropdown-item>
									<b-dropdown-item v-b-modal.modal-edit-invoice @click="selectedIdforEdit=index" v-if="['master_admin','admin','finance'].includes(role)" title="Edit">
										<b-icon icon="pencil-square"></b-icon> Edit
									</b-dropdown-item>
									<b-dropdown-item v-b-modal.modal-delete @click="deleteId=obj.id;itemToDelete=obj" v-if="['master_admin','admin'].includes(role)" title="Delete">
										<b-icon icon="trash"></b-icon> Delete
									</b-dropdown-item>
									</b-dropdown>

								</td>
							
							</template>
							
					</datatable>
					<!-- Pagination info + Prev Next -->
					<div class="d-flex justify-content-between align-items-center mt-2">

						<!-- Showing info -->
						<div class="text-muted">
							Showing {{ (currentPage - 1) * perPage + 1 }}
							to {{ ((currentPage - 1) * perPage) + filteredInvoiceAirtimes.length }}
							of {{ totalItems }} entries
						</div>

						<!-- Prev Next Buttons -->
						<div>
							<b-button 
								class="mr-2"
								variant="outline-primary"
								:disabled="!prevUrl"
								@click="changePage(false)"
							>
								Prev
							</b-button>

							<b-button 
								variant="outline-primary"
								:disabled="!nextUrl"
								@click="changePage(true)"
							>
								Next
							</b-button>
						</div>

					</div>
					</div>
				<!--RENEWAL-->
				<b-modal id="modal-renewal-invoice" title="RENEWAL" scrollable no-close-on-backdrop size="lg"
				         v-if="invoiceairtimes.length>0">
					<div class="row" v-if="invoiceairtimes[selectedIdforEdit]!=undefined">
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">SPKP ID</label>
							<div class="form-control w-100 rounded">
								{{
									invoiceairtimes[selectedIdforEdit].invoice_item_metadata != undefined
									&& invoiceairtimes[selectedIdforEdit].invoice_item_metadata != null
										? invoiceairtimes[selectedIdforEdit].invoice_item_metadata.order_metadata.hardware_setup.id_transmitter
										: "-"
								}}
							</div>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">SERIAL NUMBER</label>
							<div class="form-control w-100 rounded">
								{{
									invoiceairtimes[selectedIdforEdit].invoice_item_metadata != undefined
									&& invoiceairtimes[selectedIdforEdit].invoice_item_metadata != null
										? invoiceairtimes[selectedIdforEdit].invoice_item_metadata.order_metadata.hardware_setup.serial_number != null
											? invoiceairtimes[selectedIdforEdit].invoice_item_metadata.order_metadata.hardware_setup.serial_number.serial_number
											: "-"
										: "-"
								}}
							</div>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">NO JB</label>
							<div class="form-control w-100 rounded">
								{{
									invoiceairtimes[selectedIdforEdit].invoice_item_metadata != undefined
									&& invoiceairtimes[selectedIdforEdit].invoice_item_metadata != null
									&& invoiceairtimes[selectedIdforEdit].invoice_item_metadata.order_metadata.hardware_setup.jb != null
										? invoiceairtimes[selectedIdforEdit].invoice_item_metadata.order_metadata.hardware_setup.jb.serial_number
										: "-"
								}}
							</div>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">SHIP NAME </label>
							<div class="form-control w-100 rounded">
								{{
									invoiceairtimes[selectedIdforEdit].invoice_item_metadata != undefined
									&& invoiceairtimes[selectedIdforEdit].invoice_item_metadata != null
										? invoiceairtimes[selectedIdforEdit].invoice_item_metadata.order_metadata.hardware_setup.vessel.name
										: "-"
								}}
							</div>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">STATUS REPORT</label>
							<div class="form-control w-100 rounded">
								{{
									invoiceairtimes[selectedIdforEdit].invoice_item_metadata != undefined
									&& invoiceairtimes[selectedIdforEdit].invoice_item_metadata != null
										? invoiceairtimes[selectedIdforEdit].invoice_item_metadata.order_metadata.hardware_setup.forward
										: "-"
								}}
							</div>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">GT</label>
							<div class="form-control w-100 rounded">
								{{
									invoiceairtimes[selectedIdforEdit].invoice_item_metadata != undefined
									&& invoiceairtimes[selectedIdforEdit].invoice_item_metadata != null
										? invoiceairtimes[selectedIdforEdit].invoice_item_metadata.order_metadata.hardware_setup.vessel.gt
										: "-"
								}}
							</div>
						</div>
						
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">OWNER</label>
							<div class="form-control w-100 rounded">
								{{
									invoiceairtimes[selectedIdforEdit].invoice_item_metadata != 
									undefined && invoiceairtimes[selectedIdforEdit].invoice_item_metadata != null ? 
									invoiceairtimes[selectedIdforEdit].invoice_item_metadata.order_metadata.hardware_setup.vessel.client.legal_name : "-"
								}}
							</div>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">NO INVOICE</label>
							<!-- <input type="text" class="form-control w-100 rounded"
							       v-model="invoiceairtimes[selectedIdforEdit].invoice_no"/> -->
							<div class="input-group">
								<!-- Nomor urut -->
								<input type="text" class="form-control w-25 rounded"
									v-model="invoiceId"
									@input="updateInvoiceNumberRenewal"
									maxlength="6"
									style="background-color: #ffffff;" />

								<!-- Bulan romawi -->
								<select class="form-control w-25 rounded"
									v-model="selectedMonth"
									@change="updateInvoiceNumberRenewal">
									<option v-for="(roman, index) in romanMonths"
									:key="index"
									:value="roman">
									{{ roman }}
									</option>
								</select>

								<!-- Tahun -->
								<input type="number" class="form-control w-25 rounded"
									v-model="selectedYear"
									@input="updateInvoiceNumberRenewal"
									min="2000"
									style="background-color: #ffffff;" />

								<!-- HASIL AKHIR -->
								<input type="text" class="form-control w-75 rounded"
									v-model="invoiceairtimes[selectedIdforEdit].invoice_no"
									readonly
									style="background-color: #f0f0f0;" />
								</div>

						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">INVOICE DATE</label>
							
							<b-form-datepicker 
									today-button 
									reset-button 
									close-button 
									:date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}"
							        id="datepicker-invoice-date"
							        v-model="invoiceairtimes[selectedIdforEdit].invoice_date" 
									class="mb-2">
									{{ invoiceairtimes[selectedIdforEdit].invoice_date }}
							</b-form-datepicker>
							
						</div>
					
							<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">DUE DATE</label>
							<b-form-datepicker today-button reset-button close-button 
									:date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}"
							        id="datepicker-due-date"
							        v-model="invoiceairtimes[selectedIdforEdit].due_date_invoice"
							        class="mb-2">{{ invoiceairtimes[selectedIdforEdit].due_date_invoice }}
							</b-form-datepicker>
							
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">START OF AIRTIME</label>
							<b-form-datepicker today-button reset-button close-button 
											  :date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}"
							                   id="datepicker-start-period"
							                   v-model="invoiceairtimes[selectedIdforEdit].start_period" class="mb-2">
								{{ invoiceairtimes[selectedIdforEdit].start_period }}
							</b-form-datepicker>
						</div>
						
						<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">DURASI AIRTIME</label>
								<div class="form-control w-100 rounded">
									{{ invoiceairtimes[selectedIdforEdit].airtime_month_duration || 0 }}
									Month
								</div>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">HARGA AIRTIME</label>

									<smart-search 
										init url="/api/master/seeker/airtime-price" 
										usedefault
										key-tag="id"
										:default-value="invoiceairtimes[selectedIdforEdit].name_airtime_price"
										:label-tag="['name_airtime_price','price']" 
										v-on:update="(data)=>smartSearchUpdateAirtimePrice(data)"
										@clear="smartSearchUpdateAirtimePrice(null)" 
										@input="calculateAmount"
										>
									</smart-search>
								<!-- Displays price if available -->
								<div v-if="newAirtimePrice > 0" class="mt-2" text-danger>
									<strong>Price:</strong> Rp {{ newAirtimePrice.toLocaleString() }}
								</div>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">DISCOUNT</label>
							<smart-search init url="/api/master/seeker/discount" usedefault
							              :default-value="invoiceairtimes[selectedIdforEdit].discount"
							              key-tag="discount" @clear="smartSearchUpdateDiscount(null)"
							              v-on:update="(data)=>smartSearchUpdateDiscount(data)"></smart-search>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">QR code</label>
							<smart-select name="qr_code" :options="qrCodeTypeOptions" 
								usedefault
							    :default-value="invoiceairtimes[selectedIdforEdit].proforma"
							    v-on:update="(value)=>{invoiceairtimes[selectedIdforEdit].qr_code=value}">
							</smart-select>
						</div>
	                    <div class="col-12 col-md-6 col-lg-4 mt-2">
	                      <label class="d-block">BANK ACCOUNT</label>
	                      <smart-search 
								:search-value="newInvoiceAirtime.label_bank" init url="/api/master/seeker/bank" usedefault 
								:default-value="invoiceairtimes[selectedIdforEdit].bank == null ?'' : invoiceairtimes[selectedIdforEdit].bank.nama" key-tag="nama" 
								v-on:update="(data)=>{invoiceairtimes[selectedIdforEdit].id_bank=data.id}"  
								@update-direct="(label)=>newInvoiceAirtime.label_bank=label">
						  </smart-search>
	                    </div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">PRICE</label>
							<div class="form-control w-100 rounded">
								{{ invoiceairtimes[selectedIdforEdit].airtime_price | numeral("0,0") }}
							</div>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">TOTAL DISCOUNT</label>
							<div class="form-control w-100 rounded">
								{{ invoiceairtimes[selectedIdforEdit].discount | numeral("0,0") }}
							</div>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2"
						     v-if="this.invoiceairtimes[this.selectedIdforEdit].totalPPN!=undefined">
							<label class="d-block">SUB TOTAL</label>
							<div class="form-control w-100 rounded">
								{{ invoiceairtimes[selectedIdforEdit].subtotal | numeral("0,0") }}
							</div>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">PPN-VAT</label>
							<smart-select name="ppn" 
								:options="ppnTypeOptions" usedefault
							    :default-value="invoiceairtimes[selectedIdforEdit].ppn"
							    v-on:update="(value)=>{invoiceairtimes[selectedIdforEdit].ppn=value;$forceUpdate();calculateUpdateAmount()}">
							</smart-select>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">TOTAL</label>
							<div class="form-control w-100 rounded">
								{{ invoiceairtimes[selectedIdforEdit].total | numeral("0,0") }}
							</div>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">PIC</label>
							<input type="text" class="form-control w-100 rounded"
							       v-model="invoiceairtimes[selectedIdforEdit].pic"/>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">POSITION</label>
							<input type="text" class="form-control w-100 rounded"
							       v-model="invoiceairtimes[selectedIdforEdit].division"/>
						</div>
					
						<div class="col-12 mt-3">
							<div class="w-100 align-items-center justify-content-start" v-if="renuwalSave">
								<div class="alert alert-success" role="alert">
									Successfully Updated Extension Data.
								</div>
							</div>
						</div>
					</div>
					<template #modal-footer>
						<div class="w-100 text-right m-0 p-0">
							<hr>
							<div class="col-12 mt-3">
								<div class="w-100 align-items-center justify-content-start" v-if="errorUpdate">
									<div class="alert alert-danger" role="alert">
										<div class="my-0">
											<p class="d-block mt-1 text-left">Update failed.</p>
										</div>
										<div v-for="err in errorInvoiceItemList" v-bind:key="err" class="my-0">
											<p v-for="note in err" v-bind:key="note" class="d-block mt-1">{{ note }}</p>
										</div>
									</div>
								</div>
							</div>
							<div class="col-12 mt-3">
								<div class="d-flex align-items-center justify-content-start" v-if="updating">
									<div class="spinner-border" role="status" aria-hidden="true"></div>
									<strong class=" ml-2">Menyimpan data, tunggu sebentar.</strong>
								</div>
								<button class="btn btn-info float-right" type="button"
								        v-on:click="renewalInvoiceAirtime">SUBMIT
								</button>
								<b-button class="btn btn-secondary mr-2" @click="$bvModal.hide('modal-edit-invoice')">
									close
								</b-button>
							</div>
						</div>
					</template>
					
				</b-modal>
				
				<!--EDIT DATA-->

				<b-modal id="modal-edit-invoice" title="EDIT DATA" scrollable no-close-on-backdrop size="lg"
				         v-if="invoiceairtimes.length>0">
					<div class="row" v-if="invoiceairtimes[selectedIdforEdit]!=undefined">
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">SPKP ID</label>
							<div class="form-control w-100 rounded">
								{{
									invoiceairtimes[selectedIdforEdit].invoice_item_metadata != undefined
									&& invoiceairtimes[selectedIdforEdit].invoice_item_metadata != null
										? invoiceairtimes[selectedIdforEdit].invoice_item_metadata.order_metadata.hardware_setup.id_transmitter
										: "-"
								}}
							</div>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">SERIAL NUMBER</label>
							<div class="form-control w-100 rounded">
								{{
									invoiceairtimes[selectedIdforEdit].invoice_item_metadata != undefined
									&& invoiceairtimes[selectedIdforEdit].invoice_item_metadata != null
										? invoiceairtimes[selectedIdforEdit].invoice_item_metadata.order_metadata.hardware_setup.serial_number != null
											? invoiceairtimes[selectedIdforEdit].invoice_item_metadata.order_metadata.hardware_setup.serial_number.serial_number
											: "-"
										: "-"
								}}
							</div>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">NO JB</label>
							<div class="form-control w-100 rounded">
								{{
									invoiceairtimes[selectedIdforEdit].invoice_item_metadata != undefined
									&& invoiceairtimes[selectedIdforEdit].invoice_item_metadata != null
									&& invoiceairtimes[selectedIdforEdit].invoice_item_metadata.order_metadata.hardware_setup.jb != null
										? invoiceairtimes[selectedIdforEdit].invoice_item_metadata.order_metadata.hardware_setup.jb.serial_number
										: "-"
								}}
							</div>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">NAMA KAPAL</label>
							<div class="form-control w-100 rounded">
								{{
									invoiceairtimes[selectedIdforEdit].invoice_item_metadata != undefined
									&& invoiceairtimes[selectedIdforEdit].invoice_item_metadata != null
										? invoiceairtimes[selectedIdforEdit].invoice_item_metadata.order_metadata.hardware_setup.vessel.name
										: "-"
								}}
							</div>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">PEMILIK</label>
							<div class="form-control w-100 rounded">
								{{
									invoiceairtimes[selectedIdforEdit].invoice_item_metadata != undefined && invoiceairtimes[selectedIdforEdit].invoice_item_metadata != null ? invoiceairtimes[selectedIdforEdit].invoice_item_metadata.order_metadata.hardware_setup.vessel.client.legal_name : "-"
								}}
							</div>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">NO INVOICE</label>
							<input type="text" class="form-control w-100 rounded"
							       v-model="invoiceairtimes[selectedIdforEdit].invoice_no"/>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">INVOICE DATE</label>
							<b-form-datepicker today-button reset-button close-button 
										:date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}"
							        	id="datepicker-invoice-date"
							        	v-model="invoiceairtimes[selectedIdforEdit].invoice_date" class="mb-2">
									{{ invoiceairtimes[selectedIdforEdit].invoice_date }}
							</b-form-datepicker>
						</div>
						
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">DUE DATE</label>
							<b-form-datepicker today-button reset-button close-button 
									:date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}"
							        id="datepicker-due-date"
							        v-model="invoiceairtimes[selectedIdforEdit].due_date_invoice"
							        class="mb-2">{{ invoiceairtimes[selectedIdforEdit].due_date_invoice }}
							</b-form-datepicker>
						</div>
						
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">START OF AIRTIME</label>
							<b-form-datepicker today-button reset-button close-button :date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}"
							                   id="datepicker-start-period"
							                   v-model="invoiceairtimes[selectedIdforEdit].start_period" class="mb-2">
								{{ invoiceairtimes[selectedIdforEdit].start_period }}
							</b-form-datepicker>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">QR code</label>
							<smart-select name="qr_code" :options="qrCodeTypeOptions" 
								usedefault
							    :default-value="invoiceairtimes[selectedIdforEdit].proforma"
							    v-on:update="(value)=>{invoiceairtimes[selectedIdforEdit].qr_code=value}">
							</smart-select>
						</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">AIRTIME PRICE</label>
								<smart-search 
									init url="/api/master/seeker/airtime-price" 
									usedefault
									:default-value="invoiceairtimes[selectedIdforEdit].name_airtime_price"
									@clear="smartSearchUpdateAirtimePrice(null)" 
									key-tag="name_airtime_price"
									v-on:update="(data)=>smartSearchUpdateAirtimePrice(data)">
								</smart-search>
							</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">DISCOUNT</label>
							<smart-search init url="/api/master/seeker/discount" usedefault
							              :default-value="invoiceairtimes[selectedIdforEdit].discount"
							              key-tag="discount" @clear="smartSearchUpdateDiscount(null)"
							              v-on:update="(data)=>smartSearchUpdateDiscount(data)"></smart-search>
						</div>
	                    
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">PRICE</label>
							<div class="form-control w-100 rounded">
								{{ invoiceairtimes[selectedIdforEdit].airtime_price | numeral("0,0") }}
							</div>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">TOTAL DISCOUNT</label>
							<div class="form-control w-100 rounded">
								{{ invoiceairtimes[selectedIdforEdit].discount | numeral("0,0") }}
							</div>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2"
						     v-if="this.invoiceairtimes[this.selectedIdforEdit].totalPPN!=undefined">
							<label class="d-block">SUB TOTAL</label>
							
							<div class="form-control w-100 rounded">
								{{ invoiceairtimes[selectedIdforEdit].subtotal | numeral("0,0") }}
							</div>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">PPN-VAT</label>
							<smart-select name="ppn" 
								:options="ppnTypeOptions" usedefault
							    :default-value="invoiceairtimes[selectedIdforEdit].ppn"
							    v-on:update="(value)=>{invoiceairtimes[selectedIdforEdit].ppn=value;$forceUpdate();calculateUpdateAmount()}">
							</smart-select>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">TOTAL</label>
							<div class="form-control w-100 rounded">
								{{ invoiceairtimes[selectedIdforEdit].total | numeral("0,0") }}
							</div>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
	                      <label class="d-block">BANK ACCOUNT</label>
	                      <smart-search 
								:search-value="newInvoiceAirtime.label_bank" init url="/api/master/seeker/bank" usedefault 
								:default-value="invoiceairtimes[selectedIdforEdit].bank == null ?'' : invoiceairtimes[selectedIdforEdit].bank.nama" key-tag="nama" 
								v-on:update="(data)=>{invoiceairtimes[selectedIdforEdit].id_bank=data.id}"  
								@update-direct="(label)=>newInvoiceAirtime.label_bank=label">
						  </smart-search>
	                    </div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">PIC</label>
							<input type="text" class="form-control w-100 rounded"
							       v-model="invoiceairtimes[selectedIdforEdit].pic"/>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">POSITION</label>
							<input type="text" class="form-control w-100 rounded"
							       v-model="invoiceairtimes[selectedIdforEdit].division"/>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">INFORMATION</label>
							<textarea type="text" class="form-control w-100 rounded"
							          v-model="invoiceairtimes[selectedIdforEdit].notes"/>
								

						</div>

						<div class="col-12 mt-3">
							<div class="w-100 align-items-center justify-content-start" v-if="updateSaved">
								<div class="alert alert-success" role="alert">
									Berhasil Update Data Invoice Airtime.
								</div>
							</div>
						</div>
					</div>
					<template #modal-footer>
						<div class="w-100 text-right m-0 p-0">
							<hr>
							<div class="col-12 mt-3">
								<div class="w-100 align-items-center justify-content-start" v-if="errorUpdate">
									<div class="alert alert-danger" role="alert">
										<div class="my-0">
											<p class="d-block mt-1 text-left">Gagal update Invoice Airtime.</p>
										</div>
										<div v-for="err in errorInvoiceItemList" v-bind:key="err" class="my-0">
											<p v-for="note in err" v-bind:key="note" class="d-block mt-1">{{ note }}</p>
										</div>
									</div>
								</div>
							</div>
							<div class="col-12 mt-3">
								<div class="d-flex align-items-center justify-content-start" v-if="updating">
									<div class="spinner-border" role="status" aria-hidden="true"></div>
									<strong class=" ml-2">Menyimpan data, tunggu sebentar.</strong>
								</div>
								<button class="btn btn-info float-right" type="button"
								        v-on:click="updateInvoiceAirtime">Submit
								</button>
								<b-button class="btn btn-secondary mr-2" @click="$bvModal.hide('modal-edit-invoice')">
									close
								</b-button>
							</div>
						</div>
					</template>
					
				</b-modal>
				
			</div>
		</div>

		<b-modal no-close-on-esc content-class="m-0" size="lg" title="Detail invoice airtime"
		         id="modal-detail-invoice-airtime" scrollable no-close-on-backdrop>
			<b-container fluid v-if="!loadData&&invoiceairtimes.length>0">
				<b-row class="pt-1" v-if="invoiceairtimes[selectedDetail]!=undefined">
					<b-col cols="12">
						<table v-if="invoiceairtimes.length>0" rules="rows" class="table w-100"
						       style="overflow-x:auto;">
							<tbody>
							<tr>
								<th class="w-100 px-3 bg-secondary text-white" style="font-size:14pt" colspan="2"
								    scope="row">Detail invoice airtime
								</th>
							</tr>
							<tr>
								<th class="" scope="row">No invoice</th>
								<td class="">{{ invoiceairtimes[selectedDetail].invoice_no }}</td>
							</tr>
							<tr>
								<th class="" scope="row">ID transmitter</th>
								<td class="">
									{{
										invoiceairtimes[selectedDetail].invoice_item_metadata.order_metadata.hardware_setup.id_transmitter
									}}
								</td>
							</tr>
							<tr>
								<th class="" scope="row">Nomor SN</th>
								<td class="">
									{{
										invoiceairtimes[selectedDetail].invoice_item_metadata.order_metadata.hardware_setup.serial_number.serial_number
									}}
								</td>
							</tr>
							<tr>
								<th class="" scope="row">Nomor JB</th>
								<td class="">
									{{
										invoiceairtimes[selectedDetail].invoice_item_metadata.order_metadata.hardware_setup.jb != null
											? invoiceairtimes[selectedDetail].invoice_item_metadata.order_metadata.hardware_setup.jb.serial_number
											: "-"
									}}
								</td>
							</tr>
							<tr>
								<th class="" scope="row">Nama kapal</th>
								<td class="">
									{{
										invoiceairtimes[selectedDetail].invoice_item_metadata.order_metadata.hardware_setup.vessel.name
									}}
								</td>
							</tr>
							<tr>
								<th class="" scope="row">Pelanggan</th>
								<td class="">
									{{
										invoiceairtimes[selectedDetail].invoice_item_metadata.order_metadata.hardware_setup.vessel.client.legal_name
									}}
								</td>
							</tr>
							<tr>
								<th class="" scope="row">Tanggal invoice</th>
								<td class="">{{ invoiceairtimes[selectedDetail].invoice_date | timeformat }}</td>
							</tr>
							<tr>
								<th class="" scope="row">Tanggal invoice jatuh tempo</th>
								<td class="">{{ invoiceairtimes[selectedDetail].due_date_invoice | timeformat }}</td>
							</tr>
							<tr>
								<th class="" scope="row">Tanggal aktivasi</th>
								<td class="">{{ invoiceairtimes[selectedDetail].start_period | timeformat }}</td>
							</tr>
							<tr>
								<th class="" scope="row">QR code</th>
								<td class="">{{ invoiceairtimes[selectedDetail].qr_code }}</td>
							</tr>
							<tr>
								<th class="" scope="row">Harga airtime</th>
								<td class="">{{ invoiceairtimes[selectedDetail].airtime.name_airtime_price }}</td>
							</tr>
							<tr>
								<th class="" scope="row">Harga airtime (IDR)</th>
								<td class="">Rp {{ invoiceairtimes[selectedDetail].airtime_price | numeral("0,0") }}
								</td>
							</tr>
							<tr>
								<th class="" scope="row">Harga airtime (IDR)</th>
								<td class="">Rp {{ invoiceairtimes[selectedDetail].airtime_price | numeral("0,0") }}
								</td>
							</tr>
							<tr>
								<th class="" scope="row">Total (IDR)</th>
								<td class="">Rp {{ invoiceairtimes[selectedDetail].total | numeral("0,0") }}
								</td>
							</tr>
							</tbody>

						</table>
					</b-col>
				</b-row>
			</b-container>
			<template #modal-footer>
				<div class="w-100 text-right m-0 p-0">
					<hr>
					<b-button class="btn btn-secondary" @click="!$bvModal.hide('modal-detail-invoice-airtime')">Tutup
					</b-button>
				</div>
			</template>
		</b-modal>

		<b-modal no-close-on-esc content-class="m-0" id="modal-detail-histories" size="lg" title="HISTORY"
		         scrollable no-close-on-backdrop>
				 <!-- Cek jika data tersedia -->
			<div v-if="invoiceairtimes[selectedDetail]">
				<strong>
				{{
				invoiceairtimes[selectedDetail].invoice_item_metadata.order_metadata.hardware_setup.vessel.name
				}}
				</strong>
			</div>
			<datatable no-toolbar responsive :datas="histories" :structure="historyTableStructure"
			           :init="loadHistoriesData" use-seeker seeker-url="/api/report/json/invoice-airtime-history"
			           @searching="(val)=>!val.status?getHistories():histories=val.data">
				<template #customcell={obj,index}>
					<td v-if="isMobile" class="py-3">
						<ul style="list-style:none;width:100%;padding:0" class="rounded shadow bg-white p-2">																																							
							<li class="mt-2">
								<div class="text-left mx-3 pt-0">
									<small class="my-0 py-0">USER NAME																																																																																																																																																																																																																								</small>
									<br><b class="py-0 mx-0"
									       style="font-size:10pt">{{ obj.editor != null ? obj.editor.name : "-" }}</b>
								</div>
							</li>
						</ul>
					</td>
					<td v-if="!isMobile">{{ ((currentPage - 1) * perPage) + index + 1  }}</td>
					<td v-if="!isMobile">{{ obj.editor != null ? obj.editor.name : "-" }}</td>
					<td v-if="!isMobile">{{ JSON.parse(obj.old_data).created_at | timeformat }}</td>
					<td v-if="!isMobile">{{ JSON.parse(obj.old_data).invoice_no }}</td>
					<td v-if="!isMobile">{{ JSON.parse(obj.old_data).start_period | timeformat }}</td>
					<td v-if="!isMobile">{{ JSON.parse(obj.old_data).end_periode | timeformat }}</td>
					<td v-if="!isMobile">{{ JSON.parse(obj.old_data).notes }}</td>
					<td>
						<b-button 
						variant="danger"
						class="btn btn-sm"
						:href="''"
						target="_blank"
						>
						<b-icon icon="printer"></b-icon> Print PDF
						</b-button>

					</td>
				</template>
			</datatable>
			<template #modal-footer>
				<div class="w-100 text-right m-0 p-0">
					<hr>
					<b-button class="btn btn-secondary"
					          @click="(!deleteState)?$bvModal.hide('modal-detail-histories'):''">Close
					</b-button>
				</div>
			</template>
		</b-modal>

		<modal-delete url="/api/pemesanan/invoice-airtime/" @read="()=>{console.log('modal ready')}"
		              @result="deleteResult" :targetid="deleteId">
			Are you sure you want to delete the data with the following details?:<br>
			<ul>
				<li>Nomor Invoice: {{ itemToDelete.invoice_no }}</li>
			</ul>
		</modal-delete>
	</div>
</template>
<script>
import * as axios from "axios";
import Datatable from "../../components/Datatable.vue";
import SmartSelect from "../../components/SmartSelect.vue";
import SmartSearch from "../../components/SmartSearch.vue";
import ModalDelete from "../../components/ModalDelete.vue";

export default {
	components: {
		//   LTable,
		//   ChartCard,
		//   StatsCard
		"datatable": Datatable,
		"smart-select": SmartSelect,
		"smart-search": SmartSearch,
		"modal-delete": ModalDelete
	},
	
	data() {
		const currentDate = new Date();
		const year = currentDate.getFullYear();
		const monthIndex = currentDate.getMonth();
		return {
			base_ppn:11,
			currentPage: 1,
			perPage: 10,
			totalItems: 0,
			rowLimit: 10,
			nextUrl: null,
			prevUrl: null,
			role: "",
			selectedDetail: 0,
			newairtimediskonlabel: "",
			newairtimepricelabel: "",
			selectedHardwareSetup: {},
			newhardwareidlabel: "",
			isMobile: false,
			itemToDelete: {},

			invoiceairtimes: [
				{ id: 1, invoice_date: null }
			],
			invoiceairtimesNonGov: [],

			searchQuery: "",
			histories: [],
			searchValue: "",
			searchTerm: '',
			loadData: true,
			loadHistoriesData: true,
			savingNewInvoiceAirtime: false,
			errorNewInvoiceAirtime: false,
			errorInvoiceItemList: [],
			existingClientResult: [],
			newInvoiceAirtimeSaved: false,
			selectedTab: 0, // 0 = Goverment, 2 = Non Goverment
			newHardwarePrice: 0,
			newAirtimePrice: 0,
			updateAirtimePrice: 0,
			newDiscount: 0,
			updateDiscount: 0,
			selectedIdforEdit: 0,
			updateSaved: false,
			renuwalSave: false,
			errorUpdate: false,
			updating: false,
			deleteId: 0,
			invoiceId: "000",
			romanMonths: ["I","II","III","IV","V","VI","VII","VIII","IX","X","XI","XII"],
			selectedMonth: ["I","II","III","IV","V","VI","VII","VIII","IX","X","XI","XII"][monthIndex],
			selectedYear: year,
			notesError: false,

			newInvoiceAirtime: {
				invoiceNo: "",
				invoiceItemMetadataId: "",
				proforma: "no",
				startPeriod: null,
				invoiceDate: new Date(),
				dueDateInvoice: new Date(),
				airtimePriceId: "",
				airtimePrice: 0,
				airtimeMonthDuration: "",
				discount: 0,
				discountId: 0,
				id_bank:'',
				label_bank:'',
				subtotal: 0,
				total: 0,
				totalPPN: 0,
				ppn: 0,
				ppn_number: 0,
				notes: "",
				pic: "",
				division: "",
				qrCode: "yes",
				imei: "",
        		serialNumber: ""
			},
			
			formInvoiceAirtimeActive: false,
			historyTableStructure: [
				{label: "No", key: null},
				{
					label: {
						id: "USER NAME",
						en: "USER NAME"
					},
					key: null
				},
				{
					label: {
						id: "CHANGE DATE",
						en: "CHANGE DATE"
					},
					key: null
				},																																																																													
				{
					label: {
						id: "NO INVOICE",
						en: "NO INVOICE"
					},
					key: null
				},
				{
					label: {
						id: "START OF AIRTIME",
						en: "START OF AIRTIME"
					},
					key: null
				},
				{
					label: {
						id: "END OF AIRTIME",
						en: "END OF AIRTIME"
					},
					key: null
				},
				{
					label: {
						id: "INFORMATION",
						en: "INFORMATION																																																																																																																																																																																																																																											"
					},
					key: null
				},
				{
					label: {
						id: "ACTION",
						en: "ACTION"
					},
					key: null
				},
				
			],
			tableStructure: [
				
				{label: "NO", key: null},
				{label: "CID", key: null},
				{label: "NO INVOICE", key: null},
				{label: "OWNER", key: null},
				{label: "SERIAL NUMBER", key: null},
				{label: "SHIP NAME", key: null},
				{label: "DEVICE STATUS", key: null},
				{label: "STATUS REPORT", key: null},
				{label: "GT", key: null},
				{label: "NPWP", key: null},
				{label: "TYPE VASSEL", key: null},
				{label: "INVOICE DATE", key: null},
				{label: "START OF AIRTIME", key: null},
				{label: "END OF AIRTIME", key: null},
				{label: "SAP", key: null},
				{label: "ACTION", key: null}
			],
			tableStructurenongov: [
				
				{label: "NO", key: null},
				{label: "CID", key: null},
				{label: "NO INVOICE", key: null},
				{label: "OWNER", key: null},
				{label: "SERIAL NUMBER", key: null},
				{label: "SHIP NAME", key: null},
				{label: "STATUS REPORT", key: null},
				{label: "GT", key: null},
				{label: "NPWP", key: null},
				{label: "TYPE VASSEL", key: null},
				{label: "INVOICE DATE", key: null},
				{label: "START OF AIRTIME", key: null},
				{label: "END OF AIRTIME", key: null},
				{label: "ACTION", key: null}
			],
			proformaTypeOptions: [
				{label: "Tidak", value: "no"},
				{label: "Ya", value: "yes"}
			],
			qrCodeTypeOptions: [
				{label: "Ya", value: "yes"},
				{label: "Tidak", value: "no"}
			],
			ppnTypeOptions: [
				{label: "Tidak Ada PPN", value: 0},
				{ label: '11', value: 11 },
				{ label: '12', value: 12 },
				
			],
			
		};
	},
	
	created() {
		this.role = localStorage.getItem("role");
		this.$reActivateAccess(this); /*SETTIMEOUT LOGOUT OTOMATIS, (this,true) UTK MELIHAT DETIK DI BROWSHER*/
		this.getInvoiceAirtimes();
		this.getHistories();
		// this.getSetPpn();
	},

	// Convert months to Roman numerals
	computed: {
		formattedInvoiceNumber() {
			
			return `${this.invoiceId}/INV-AT-MSP/${this.selectedMonth}/${this.selectedYear}`;
		},
		filteredInvoiceAirtimes() {
			// ============================
			// 1. FILTER BERDASARKAN DATE
			// ============================
			let data = this.invoiceairtimes;

			if (this.startDate && this.endDate) {
				let start = new Date(this.startDate).getTime();
				let end = new Date(this.endDate).getTime();

				data = data.filter(item => {
					let inv = new Date(item.invoice_date).getTime();
					return inv >= start && inv <= end;
				});
			}

			if (!this.searchQuery) {
				return this.invoiceairtimes;
			}
			let keyword = this.searchQuery.toLowerCase();
			return this.invoiceairtimes.filter(obj => 
				obj.invoice_no.toLowerCase().includes(keyword) || 
				obj.invoice_item_metadata.order_metadata.hardware_setup.vessel.client.legal_name.toLowerCase().includes(keyword) ||
				obj.invoice_item_metadata.order_metadata.hardware_setup.vessel.client.customer_id.toString().includes(keyword) ||
				obj.invoice_item_metadata.order_metadata.hardware_setup.vessel.name.toLowerCase().includes(keyword)
			);
			}
		},
		
		
		filteredInvoiceAirtimesNonGov() {
			let data = this.invoiceairtimesNonGov || [];

			// FILTER DATE
			if (this.startDate && this.endDate) {
				const start = new Date(this.startDate).getTime();
				const end = new Date(this.endDate).getTime();

				data = data.filter(item => {
				if (!item.invoice_date) return false;
				const inv = new Date(item.invoice_date).getTime();
				return inv >= start && inv <= end;
				});
			}

			// TANPA SEARCH → TAMPILKAN DATA
			if (!this.searchQuery) {
				return data;
			}

			const keyword = this.searchQuery.toLowerCase();

			return data.filter(obj => {
				if (
				!obj.invoice_item_metadata ||
				!obj.invoice_item_metadata.order_metadata ||
				!obj.invoice_item_metadata.order_metadata.hardware_setup ||
				!obj.invoice_item_metadata.order_metadata.hardware_setup.vessel ||
				!obj.invoice_item_metadata.order_metadata.hardware_setup.vessel.client
				) {
				return false;
				}

				const client = obj.invoice_item_metadata.order_metadata.hardware_setup.vessel.client;
				const vessel = obj.invoice_item_metadata.order_metadata.hardware_setup.vessel;

				return (
				obj.invoice_no.toLowerCase().includes(keyword) ||
				client.legal_name.toLowerCase().includes(keyword) ||
				client.customer_id.toString().includes(keyword) ||
				vessel.name.toLowerCase().includes(keyword)
				);
			});
			
			
		},
		currentInvoiceItems() {
			return this.selectedTab === 2
			? this.invoiceitemsNonGov
			: this.invoiceairtimes;
		},

		//  Determine the active API
		currentInvoiceApi() {
			return this.selectedTab === 2
			? this.$baseUrl + "/api/pemesanan/invoice-airtime-non-goverment/"
			: this.$baseUrl + "/api/pemesanan/invoice-airtime/";
		},
	methods: {
		
		getNoInvoice(){
			axios.get(this.$baseUrl + "/api/pemesanan/no_invoice/invoice-airtime", {
				"headers": {
					"Authorization": "Bearer " + localStorage.getItem("accessToken")
				}
			}).then((result) => {
				console.log(result);
				this.newInvoiceAirtime.invoiceNo = result.data.create;
			}).catch((err) => {
				//check if token fail
			});
		},
		changePage(isNext) {
			var url = (isNext ? this.nextUrl : this.prevUrl);
			let params = (new URL(url)).searchParams;
			const myParams = params.get("page");
			this.currentPage = myParams;
			var newUrl = this.$baseUrl + "/api/pemesanan/invoice-airtime?limit=" + this.rowLimit + "&page=" + myParams;
			this.getInvoiceAirtimes(newUrl);
		},
		resetNewInvoice() {
			this.newInvoiceAirtime.invoiceNo = "";
			this.newInvoiceAirtime.invoiceItemMetadataId = "";
			this.newInvoiceAirtime.proforma = "no";
			this.newInvoiceAirtime.startPeriod;
			this.newInvoiceAirtime.invoiceDate = new Date();
			this.newInvoiceAirtime.dueDateInvoice = new Date();
			this.newInvoiceAirtime.airtimePriceId = "";
			this.newInvoiceAirtime.id_bank = "";
			this.newInvoiceAirtime.label_bank = "";
			this.newInvoiceAirtime.airtimePrice = 0;
			this.newInvoiceAirtime.airtimeMonthDuration = "";
			this.newInvoiceAirtime.discount = 0;
			this.newInvoiceAirtime.discountId = 0;
			this.newInvoiceAirtime.subtotal = 0;
			this.newInvoiceAirtime.total = 0;
			this.newInvoiceAirtime.totalPPN = 0;
			this.newInvoiceAirtime.ppn = "yes";
			this.newInvoiceAirtime.ppn_number = "0";
			this.newInvoiceAirtime.notes = "";
			this.newInvoiceAirtime.pic = "";
			this.newInvoiceAirtime.division = "";
			this.newInvoiceAirtime.qrCode = "no";
			this.newhardwareidlabel = "";
			this.selectedHardwareSetup = {};
			this.newairtimepricelabel = "";
			this.newairtimediskonlabel = "";
		},
		doSearch() {
			this.getInvoiceAirtimes(null, this.searchTerm);
		},
		getInvoiceAirtimes(url = null, search = '') {
			this.loadData = true;

			let finalUrl = url;
			if (!finalUrl) {
				finalUrl = `${this.$baseUrl}/api/pemesanan/invoice-airtime?limit=${this.rowLimit}`;
				if (search) {
				finalUrl += `&search=${encodeURIComponent(search)}`;
				}
			}

			axios.get(finalUrl, {
				headers: {
				Authorization: "Bearer " + localStorage.getItem("accessToken")
				}
			}).then((result) => {
				console.log("Hasil invoice:", result);
				
				this.prevUrl = result.data.prev_page_url;
				this.nextUrl = result.data.next_page_url;
				this.currentPage = result.data.current_page;
				this.perPage = parseInt(result.data.per_page);
				this.totalItems = result.data.total;

				this.invoiceairtimes = result.data.data;
				this.loadData = false;
			}).catch((err) => {
				if (err.response && err.response.status === 401) {
				localStorage.removeItem("accessToken");
				this.$router.push("/login");
				}
				console.error(err);
				this.loadData = false;
			});
		},
		
		getInvoiceAirtimesNonGov(url = null, search = "") {
            this.loadData = true;

            let finalUrl = url;
            if (!finalUrl) {
                finalUrl = `${this.$baseUrl}/api/pemesanan/invoice-airtime-non-goverment?limit=${this.rowLimit}`;
                if (search) {
                    finalUrl += `&search=${encodeURIComponent(search)}`;
                }
            }

            axios.get(finalUrl, {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("accessToken")
                }
            })
            .then((result) => {
                console.log("NonGov Result:", result.data);

                this.prevUrl = result.data.prev_page_url;
                this.nextUrl = result.data.next_page_url;
                this.currentPage = result.data.current_page;
                this.perPage = parseInt(result.data.per_page);
                this.totalItems = result.data.total;

                this.invoiceairtimesNonGov = result.data;

                this.loadData = false;
            })
            .catch((err) => {
                if (err.response && err.response.status === 401) {
                    localStorage.removeItem("accessToken");
                    this.$router.push("/login");
                }
                console.error(err);
                this.loadData = false;
            });
        },

		getHistories(id) {
			var url = this.$baseUrl + "/api/report/json/invoice-airtime-history/" + id;
			this.loadHistoriesData = true;
			axios.get(url, {
				"headers": {
					"Authorization": "Bearer " + localStorage.getItem("accessToken")
				}
			}).then((result) => {
				console.log(result);
				this.histories = result.data;
				this.loadHistoriesData = false;
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				console.log(err);
				this.loadHistoriesData = false;
			});
		},

		deleteResult(deleted) {
			console.log(deleted);
			if (deleted) {
				this.getInvoiceAirtimes();
			}
		},
		
		calculateAmount() {
			
			if (this.newInvoiceAirtime.airtimePrice > 0) {
            if (this.newDiscount.discount_type != undefined) {
                if (this.newDiscount.discount_type == "nominal") {
                    this.newInvoiceAirtime.discount = this.newDiscount.price;
                } else {
                    this.newInvoiceAirtime.discount = this.newInvoiceAirtime.airtimePrice * this.newDiscount.price / 100;
                }
            } else {
                this.newInvoiceAirtime.discount = 0;
            }
            
            this.newInvoiceAirtime.subtotal = parseInt(this.newInvoiceAirtime.airtimePrice) - parseInt(this.newInvoiceAirtime.discount);
            
            if (this.newInvoiceAirtime.ppn != null) { // Ensure PPN is selected
                this.newInvoiceAirtime.totalPPN = Math.round((this.newInvoiceAirtime.subtotal * (this.base_ppn / 100)));
                this.newInvoiceAirtime.total = Math.round((this.newInvoiceAirtime.subtotal + this.newInvoiceAirtime.totalPPN) / 10) * 10;
            } else {
                this.newInvoiceAirtime.total = this.newInvoiceAirtime.subtotal;
                this.newInvoiceAirtime.totalPPN = 0;
            }

				console.log("subtotal: " + this.newInvoiceAirtime.subtotal);
				console.log("PPN: " + this.base_ppn + "%");
				console.log("totalPPN: " + this.newInvoiceAirtime.totalPPN);
				console.log("total: " + this.newInvoiceAirtime.total);
				
			} else {
				this.newInvoiceAirtime.subtotal = 0;
			}
		},
		calculateUpdateAmount() {
			
			const selectedItem = this.invoiceairtimes[this.selectedIdforEdit];
			if (!selectedItem) return;

			// Reset nilai default
			selectedItem.discount = 0;
			selectedItem.subtotal = 0;
			selectedItem.total = 0;

			selectedItem.ppn_number = selectedItem.ppn;

			if (selectedItem.airtime_price > 0) {
			
			if (this.updateDiscount && this.updateDiscount.discount_type) {
				if (this.updateDiscount.discount_type === "nominal") {
				selectedItem.discount = this.updateDiscount.price || 0;
				} else if (this.updateDiscount.discount_type === "percentage") {
				selectedItem.discount =
					(selectedItem.airtime_price * this.updateDiscount.price) / 100;
				}
			}
			selectedItem.subtotal = selectedItem.airtime_price - selectedItem.discount;

			if (selectedItem.ppn > 0) {
				
				const calculatedPPN = (selectedItem.subtotal * selectedItem.ppn) / 100;
				
				selectedItem.total = selectedItem.subtotal + calculatedPPN;
			} else {
				
				selectedItem.total = selectedItem.subtotal;
			}
			}
		},

		// Monitor changes to VAT to automatically recalculate
		watch: {
			"invoiceairtimes[selectedIdforEdit].ppn"(newValue) {
			this.calculateUpdateAmount();
			},
			"invoiceairtimes[selectedIdforEdit].airtime_price"(newValue) {
			this.calculateUpdateAmount();
			},
			"updateDiscount.price"(newValue) {
			this.calculateUpdateAmount();
			},
			'newInvoiceAirtime.ppn'(newValue) {
				// this.newInvoiceAirtime.ppn_number = newValue;
				 const selectedOption = this.ppnTypeOptions.find(option => option.value === newValue);
				 this.newInvoiceAirtime.ppn_number = selectedOption ? selectedOption.value : null;
    			 console.log("PPN Updated via Watcher:", this.newInvoiceAirtime.ppn_number);
			},
			selectedIdforEdit(newVal) {
				const selected = this.invoiceairtimes[newVal]
				if (!selected.invoice_date) {
					// kalau belum ada tanggal, isi otomatis hari ini
					this.invoiceairtimes[newVal].invoice_date = new Date()
				}
			}
		},
		updateNewIiProforma(data) {
			this.newInvoiceAirtime.proforma = data;
		},
		updateNewQrCode(data) {
			this.newInvoiceAirtime.qrCode = data;
		},
		
		updateNewPpn(data) {
			this.newInvoiceAirtime.ppn = data;
			this.newInvoiceAirtime.ppn_number = data;
			this.base_ppn = data;
			this.calculateAmount();
		},
		
		updateNewIiAirtime(data) {
			this.newInvoiceAirtime.airtime = data;
		},

		// savenewInvoiceAirtime() {

		// 		this.savingNewInvoiceAirtime = true;
		// 		this.errorNewInvoiceAirtime = false;
		// 		console.log(this.newInvoiceAirtime);
				
		// 		if (
		// 			this.newInvoiceAirtime.invoiceNo != "" &&
		// 			this.newInvoiceAirtime.invoiceItemMetadataId != "" &&
		// 			// this.newInvoiceAirtime.startPeriod != "" &&
		// 			this.newInvoiceAirtime.invoiceDate != "" &&
		// 			this.newInvoiceAirtime.dueDateInvoice != "" &&
		// 			this.newInvoiceAirtime.airtimePriceId != "" &&
		// 			this.newInvoiceAirtime.airtimeMonthDuration != "" &&
		// 			this.newInvoiceAirtime.total != ""
		// 		) {
		// 			axios.post(
		// 				this.$baseUrl + "/api/pemesanan/invoice-airtime",
		// 				{
		// 					"invoice_no": this.newInvoiceAirtime.invoiceNo,
		// 					"invoice_item_metadata_id": this.newInvoiceAirtime.invoiceItemMetadataId,
		// 					// "start_period": this.newInvoiceAirtime.startPeriod,
		// 					start_period: this.newInvoiceAirtime.startPeriod && this.newInvoiceAirtime.startPeriod !== "" 
        //                       ? this.newInvoiceAirtime.startPeriod 
        //                       : null,
		// 					"invoice_date": this.newInvoiceAirtime.invoiceDate,
		// 					"due_date_invoice": this.newInvoiceAirtime.dueDateInvoice,
		// 					"proforma": this.newInvoiceAirtime.proforma,
		// 					"qr_code": this.newInvoiceAirtime.qrCode,
		// 					"ppn": this.newInvoiceAirtime.ppn,
		// 					"ppn_number": this.newInvoiceAirtime.ppn_number,
		// 					"airtime_price_id": this.newInvoiceAirtime.airtimePriceId,
		// 					"airtime_price": this.newInvoiceAirtime.airtimePrice,
		// 					"airtime_month_duration": this.newInvoiceAirtime.airtimeMonthDuration,
		// 					"discount": this.newInvoiceAirtime.discount,
		// 					"discount_id": this.newInvoiceAirtime.discountId,
		// 					"pic": this.newInvoiceAirtime.pic,
		// 					"id_bank": this.newInvoiceAirtime.id_bank,
		// 					"division": this.newInvoiceAirtime.division,
		// 					"total": this.newInvoiceAirtime.total,
		// 					"notes": this.newInvoiceAirtime.notes,
		// 					// "end_periode":this.newInvoiceAirtime.endPeriode
		// 					end_periode: null
		// 				},
		// 				{
		// 					"headers":
		// 						{
		// 							"Authorization": "Bearer " + localStorage.getItem("accessToken")
		// 						}
		// 				}
		// 			).then((result) => {
		// 				console.log(result);
		// 				this.savingNewInvoiceAirtime = false;
		// 				this.newInvoiceAirtimeSaved = true;
		// 				this.resetNewInvoice();
		// 				this.getInvoiceAirtimes();
		// 				setTimeout(() => {
		// 					this.formInvoiceAirtimeActive = false;
		// 					this.newInvoiceAirtimeSaved = false;
		// 				}, 1000);
		// 			}).catch((err) => {
		// 				if (err.response && err.response.status == 400) {
		// 					console.log(err.response.data.error); 
		// 					this.errorNewInvoiceAirtime = true;
		// 				} else if (err.response && err.response.status == 401) {
		// 					localStorage.removeItem("accessToken");
		// 					this.$router.push("/login");
		// 				} else {
		// 					console.clear();
		// 					console.log(err.response);
		// 					this.savingNewInvoiceAirtime = false;
		// 					this.errorNewInvoiceAirtime = true;
		// 				}
		// 			});
		// 		} else {
		// 			console.log("data invalid");
		// 			this.errorNewInvoiceAirtime = true;
		// 		}
		// },	
		
		savenewInvoiceAirtime() {
			this.savingNewInvoiceAirtime = true;
			this.errorNewInvoiceAirtime = false;

			// Tangani startPeriod kosong / invalid
			let startPeriod = this.newInvoiceAirtime.startPeriod;
			if (!startPeriod || startPeriod === "" || startPeriod === "Invalid date") {
				startPeriod = null;
			}

			// Check mandatory fields (startPeriod is not mandatory)
			if (
				this.newInvoiceAirtime.invoiceNo &&
				this.newInvoiceAirtime.invoiceItemMetadataId &&
				this.newInvoiceAirtime.invoiceDate &&
				this.newInvoiceAirtime.dueDateInvoice &&
				this.newInvoiceAirtime.airtimePriceId &&
				this.newInvoiceAirtime.airtimeMonthDuration &&
				this.newInvoiceAirtime.total
			) {
				axios.post(
					this.$baseUrl + "/api/pemesanan/invoice-airtime",
					{
						invoice_no: this.newInvoiceAirtime.invoiceNo,
						invoice_item_metadata_id: this.newInvoiceAirtime.invoiceItemMetadataId,
						start_period: startPeriod,
						invoice_date: this.newInvoiceAirtime.invoiceDate,
						due_date_invoice: this.newInvoiceAirtime.dueDateInvoice,
						proforma: this.newInvoiceAirtime.proforma,
						qr_code: this.newInvoiceAirtime.qrCode,
						ppn: this.newInvoiceAirtime.ppn,
						ppn_number: this.newInvoiceAirtime.ppn_number,
						airtime_price_id: this.newInvoiceAirtime.airtimePriceId,
						airtime_price: this.newInvoiceAirtime.airtimePrice,
						airtime_month_duration: this.newInvoiceAirtime.airtimeMonthDuration,
						discount: this.newInvoiceAirtime.discount,
						discount_id: this.newInvoiceAirtime.discountId,
						pic: this.newInvoiceAirtime.pic,
						id_bank: this.newInvoiceAirtime.id_bank,
						division: this.newInvoiceAirtime.division,
						total: this.newInvoiceAirtime.total,
						notes: this.newInvoiceAirtime.notes,
						end_periode: null
					},
					{
						headers: { Authorization: "Bearer " + localStorage.getItem("accessToken") }
					}
				).then((res) => {
					this.savingNewInvoiceAirtime = false;
					this.newInvoiceAirtimeSaved = true;
					this.resetNewInvoice();
					this.getInvoiceAirtimes();
					setTimeout(() => {
						this.formInvoiceAirtimeActive = false;
						this.newInvoiceAirtimeSaved = false;
					}, 1000);
				}).catch((err) => {
					console.log(err.response.data.error || err.response);
					this.savingNewInvoiceAirtime = false;
					this.errorNewInvoiceAirtime = true;
				});
			} else {
				console.log("Data invalid, wajib isi field yang perlu");
				this.savingNewInvoiceAirtime = false;
				this.errorNewInvoiceAirtime = true;
			}
		},
		validateAndUpdate() {
			const notes = this.invoiceairtimes[this.selectedIdforEdit].notes;

			if (!notes || notes.trim() === '') {
			this.notesError = true;

			this.$bvToast.toast('Field INFORMATION wajib diisi.', {
				title: 'Peringatan',
				variant: 'danger',
				solid: true,
			});

			return;
			}

			this.notesError = false;
			this.updateInvoiceAirtime(); 
			this.renewalInvoiceAirtime(); 
		},
		
		updateInvoiceAirtime() {
			this.updating = true;

			axios.put(
				this.$baseUrl + "/api/pemesanan/invoice-airtime/" +
				this.invoiceairtimes[this.selectedIdforEdit].id,
				{
					...this.invoiceairtimes[this.selectedIdforEdit],
					is_renewal: false   // EDIT
				},
				{ headers: { Authorization: "Bearer " + localStorage.getItem("accessToken") } }
			)
			.then((result) => {
				if (result.status === 200) {
					this.updating = false;
					this.updateSaved = true;
					this.renuwalSave = true;

					setTimeout(() => {
						this.updateSaved = false;
						this.renuwalSave = false;
						this.$bvModal.hide("modal-edit-invoice");
					}, 1000);
				}
				console.log(result);
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				this.updating = false;
				this.errorUpdate = true;
				console.log(err.response);
			});
		},
		renewalInvoiceAirtime() {
			this.updating = true;

			axios.put(
				this.$baseUrl + "/api/pemesanan/invoice-airtime/" +
				this.invoiceairtimes[this.selectedIdforEdit].id,
				{
					...this.invoiceairtimes[this.selectedIdforEdit],
					is_renewal: true    // RENEWAL
				},
				{ headers: { Authorization: "Bearer " + localStorage.getItem("accessToken") } }
			)
			.then((result) => {
				if (result.status === 200) {
					this.updating = false;
					this.updateSaved = true;
					this.renuwalSave = true;

					setTimeout(() => {
						this.updateSaved = false;
						this.renuwalSave = false;
						this.$bvModal.hide("modal-renewal-invoice");
					}, 1000);
				}
				console.log(result);
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				this.updating = false;
				this.errorUpdate = true;
				console.log(err.response);
			});
		},

		newUsernameChange() {
			this.newInvoiceAirtime.password = this.newInvoiceAirtime.username.toUpperCase();
		},
		deleteItem(item) {
			console.log("button delete untuk user id: " + item.id);
		},
		updateUserRoleValue(newValue) {
			this.newInvoiceAirtime.role = newValue;
		},
		setNewClientId(newId) {
			this.newInvoiceAirtime.clientId = newId;
			console.log(this.newInvoiceAirtime.clientId);
		},
		smartSearchAddIdTransmitter(data) {
			this.newInvoiceAirtime.invoiceItemMetadataId = data.order_metadata.invoice_item_metadata.id;
			this.selectedHardwareSetup = data;
			this.newInvoiceAirtime.imei = data.imei;
      		this.newInvoiceAirtime.serialNumber = data.serial_number;
			
		},
		smartSearchHardwarePrice(data) {
			this.newHardwarePrice = data.price;
			this.calculateAmount();
		},
		smartSearchAirtimePrice(data) {
			this.newInvoiceAirtime.airtimePrice = data.price;
			this.newInvoiceAirtime.airtimeMonthDuration = data.month_duration;
			this.newInvoiceAirtime.airtimePriceId = data.id;
			this.newAirtimePrice = data;
			this.$forceUpdate();
			this.calculateAmount();
			if (data && data.price) {
            	this.newAirtimePrice = data.price; // Ambil harga dari data
        	}
		},
		smartSearchUpdateAirtimePrice(data) {
			
			if (data) {
				this.invoiceairtimes[this.selectedIdforEdit].airtime_price = data.price;
				this.invoiceairtimes[this.selectedIdforEdit].airtime_month_duration = data.month_duration;
				this.invoiceairtimes[this.selectedIdforEdit].airtime_price_id = data.id;
			} else {
				this.invoiceairtimes[this.selectedIdforEdit].airtime_price = 0;
				this.invoiceairtimes[this.selectedIdforEdit].airtime_month_duration = 0;
				this.invoiceairtimes[this.selectedIdforEdit].airtime_price_id = null;
			}

			this.calculateUpdateAmount(); 
			this.$forceUpdate(); 
		},
		smartSearchDiscount(data) {
			if (data == null) {
				this.newInvoiceAirtime.discount = 0;
				this.newInvoiceAirtime.discountId = 0;
				this.newDiscount = {};
				this.$forceUpdate();
				return;
			}

			this.newInvoiceAirtime.discountId = data.id;
			this.newInvoiceAirtime.discount = data.price;
			this.newDiscount = data;
			this.$forceUpdate();
			this.calculateAmount();
		},
		smartSearchUpdateDiscount(data) {
			if (data == null) {
				this.invoiceairtimes[this.selectedIdforEdit].discount = 0;
				this.invoiceairtimes[this.selectedIdforEdit].discount_id = "";
				this.updateDiscount = {};
				this.$forceUpdate();
				return;
			}

			this.invoiceairtimes[this.selectedIdforEdit].discount_id = data.id;
			this.invoiceairtimes[this.selectedIdforEdit].discount = data.price;
			this.updateDiscount = data;
			this.$forceUpdate();
			this.calculateUpdateAmount();
		},
		updateKapal(data) {
			console.log(data.kapal_id.id);
			this.newInvoiceAirtime.vessel_id = data.kapal_id.id;
		},
		
		validateInvoiceId() {
			this.invoiceId = this.invoiceId.replace(/\D/g, '').slice(0, 6); 
    		this.updateInvoiceNumber();
		},

		updateInvoiceNumber() {
		
			this.newInvoiceAirtime.invoiceNo = this.formattedInvoiceNumber;
		},
		updateInvoiceNumberRenewal() {
			if (!this.selectedIdforEdit && this.selectedIdforEdit !== 0) return;

			const seq   = this.invoiceId.toString().padStart(4, '0');
			const month = this.selectedMonth;
			const year  = this.selectedYear;

			const invoiceNo = `${seq}/INV-AT-MSP/${month}/${year}`;

			
			this.invoiceairtimes[this.selectedIdforEdit].invoice_no = invoiceNo;
		},

		applyFilter(result) {
			// console.log("APPLY FILTER:", result);

			if (!result.status) {
				this.invoiceairtimes = [];   
				this.nextUrl = null;
				this.prevUrl = null;
				return;
			}

			// Laravel pagination
			if (result.data.data) {
				this.invoiceairtimes = result.data.data; 
				this.nextUrl = result.data.next_page_url;
				this.prevUrl = result.data.prev_page_url;
			}
			// No pagination
			else {
				this.invoiceairtimes = result.data;    
				this.nextUrl = null;
				this.prevUrl = null;
			}

			this.currentPage = 1;
		},
		govermentTabe() {
			this.selectedTab = 0;               
			this.getInvoiceAirtimes();        
		},



		

	},
	mounted() {
		this.updateInvoiceNumber();
		this.getInvoiceAirtimes();
		this.getInvoiceAirtimesNonGov();

		
    	
  	},
	
};
</script>
<style scoped>
.btn {
	padding: 2px 6px;
}

/* ::v-deep .modal.show .modal-dialog {
    transform: translate(0px, 10%);
}
::v-deep .modal-dialog-scrollable .modal-content {
    max-height: calc(100vh - 1rem);
} */
.table > thead > tr > th, .table > tbody > tr > th, .table > tfoot > tr > th, .table > thead > tr > td, .table > tbody > tr > td, .table > tfoot > tr > td {
	width: 50%;
}
.text-danger {
    color: red;
}
.search-container {
  position: relative; 
  width: 100%; 
  margin-top: 15px; 
  padding-left: 0;
  margin-left: 0%; 
}

.search-input {
  position: absolute;
  left: 80%; 
  top: 20px; 
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
  width: 20%; 
}


</style>
